import Error404 from './Error404.page';

export default Error404;
